export default __webpack_public_path__ + "static/media/favicon-32x32.9006473e.png";